import {
  // Crendentials => expect json web token as return
  CREATE_VANILLA_AUTHENTICATION_CREDENTIALS,
  CREATE_IDENTITY_AUTHENTICATION_CREDENTIALS,
  // Identity => expect identity return
  CREATE_LINKEDIN_AUTHENTICATION_IDENTITY,

  CREATE_RESOURCE_AUTHENTICATION_ERROR,
  CREATE_RESOURCE_CREDENTIALS_SUCCESS,
  CREATE_RESOURCE_IDENTITY_SUCCESS,
} from '../actions/auth';
import { SIGNIN_ABORT } from '../scenes/onboarding/signin/actions/signin';

/*
 * Oauth2 Phases (from Frontend PoV)
 * 1. fontend -> provider - Callback
 * 2. frontend -> backend - Authorization
 * 3  backend <-> provider - Exchange auth code access token for identity
 * 4. backend -> Frontend - return identity (ok to register) | user (account exists / login)
 *
 * Statuses
 * - can register
 * - can sign in
 */

const defaultState = {
  phase: null, // Oauth phase cf above
  provider: null, // provider used for Oauth
  pending: false, // Pending background request independent of user
};

const oauth = (state = defaultState, action) => {
  switch(action.type) {
    case CREATE_LINKEDIN_AUTHENTICATION_IDENTITY:
      return {
        ...state,
        phase: 'authorization',
        pending: true,
      };
    case CREATE_RESOURCE_IDENTITY_SUCCESS:
      // Note at this point we can register
      return {
        ...state,
        phase: null,
        pending: false,
      };
    case CREATE_IDENTITY_AUTHENTICATION_CREDENTIALS:
      return {
        ...state,
        phase: 'registration',
        success: null,
        pending: true,
      };
    case CREATE_RESOURCE_AUTHENTICATION_ERROR:
      return {
        ...state,
        status: 'failure',
        phase: null,
        pending: false,
      };
    // If we get credentials => account exists. We then get the profile
    case '@@api/CREATE_RESOURCE_USER_SUCCESS':
    case CREATE_RESOURCE_CREDENTIALS_SUCCESS:
      return {
        ...state,
        status: 'authenticated',
        phase: null,
      };

    // after getting the user profile, we usually have somewhere to go
    case '@@api/READ_RESOURCE_USER_SUCCESS':
    case '@@api/READ_RESOURCE_USER_ERROR': {
      return {
        ...state,
        pending: false,
      };
    }
    // Reset if user switched back to vanilla auth
    // (user failure will prevent infinite loader)
    case '@@api/CREATE_RESOURCE_USER_ERROR':
      return {
        ...state,
        status: null,
        phase: null,
        provider: null,
        pending: false,
      };
    // Auth using email/pw => mark as pending
    case CREATE_VANILLA_AUTHENTICATION_CREDENTIALS:
      return {
        ...state,
        status: null,
        phase: null,
        provider: null,
        pending: true,
      };

    case SIGNIN_ABORT:
      return {
        ...state,
        pending: false,
      };

    default: return state;
  }
};

export default oauth;
